import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private sentryHandler = Sentry.createErrorHandler({ logErrors: false });

  handleError(error: unknown): void {
    Sentry.withScope((scope) => {
      scope.setExtra('rawMessage', String(error));
      scope.setExtra('userAgent', navigator.userAgent);
      scope.setExtra('viewport', `${window.innerWidth}x${window.innerHeight}`);
      this.sentryHandler.handleError(error);
    });

    const msg = error instanceof Error ? error.message : String(error);
    console.error('[GlobalErrorHandler]', error);

    const snackBar = this.injector.get(MatSnackBar, null);
    if (snackBar) {
      snackBar.open(msg.slice(0, 200), 'Dismiss', {
        duration: 10_000,
        panelClass: ['zw-error-toast'],
      });
    } else {
      const el = document.getElementById('boot-fallback-log');
      if (el) el.textContent += '[error] ' + msg + '\n';
    }
  }
}
